export const environment = {
  production: true,
  skipHub: false,
  baseUrl: document.getElementsByTagName("base")[0].href,
  version: "%%version%%"
};
